import { render } from "./ProductTab.vue?vue&type=template&id=05570b28&scoped=true"
import script from "./ProductTab.vue?vue&type=script&lang=js"
export * from "./ProductTab.vue?vue&type=script&lang=js"

import "./ProductTab.vue?vue&type=style&index=0&id=05570b28&lang=scss&scoped=true"

import exportComponent from "/Users/smzdm/Desktop/前端项目/畅效官网/cx_official_website/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05570b28"]])

export default __exports__